<template>
  <div>
    <div class="row border-bottom">
      <nav class="navbar navbar-static-top navbar-fixed-top" 
          v-bind:style="{
            backgroundColor: color + ' !important',
            marginTop: '0px'
          }">
        <div class="navbar-header">
          <span>
            <a 
              v-bind:style="{
                backgroundColor: color + ' !important',
                borderColor: color + ' !important'
              }"
            class="navbar-minimalize minimalize-styl-2 btn btn-primary" @click="minimalize">
              <i class="el-icon-s-fold"></i>
            </a>
          </span>
        </div>
        <ul class="nav navbar-top-links navbar-right">
          
          <!--li class="dropdown" :class="{'open':openLanuage}" >

              <a class="dropdown-toggle count-info" @click="openLanuage=true;" style="padding: 10px;">
                   <img src="../../assets/web.png" style="width: 27px;"/>
              </a>
              <ul class="dropdown-menu animated fadeInRight m-t-xs">
                  <li><a @click="changeLanguage('en_US')">English</a></li>
                  <li><a @click="changeLanguage('zh_HK')">繁體中文</a></li>
                  <li><a @click="changeLanguage('zh_CN')">简体中文</a></li>
              </ul>
          </li-->
          <li>
            <span style="color: white">{{$store.state.userInfo.userName}}</span>
          </li>
          <li @click="logOut">
            <a>
              <i class="el-icon-right"></i>
               {{$t("message.LogOut") }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import config from "../../config";
export default {
  mixins: [config.globalMixin],
  name: "topnavbarController",
  data() {
    return {
      openLanuage:false,
      color:""
    };
  },
  methods: {
    minimalize() {
      $("body").toggleClass("mini-navbar");
      if (
        !$("body").hasClass("mini-navbar") ||
        $("body").hasClass("body-small")
      ) {
        $("#side-menu").hide();
        setTimeout(function() {
          $("#side-menu").fadeIn(500);
        }, 100);
      } else if ($("body").hasClass("fixed-sidebar")) {
        $("#side-menu").hide();
      } else {
        $("#side-menu").removeAttr("style");
      }
    },
    async logOut() {
      let objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.logout
      let data = await this.$store.dispatch("apiEvent", objdata);
      this.$router.push({ path: "/" });
    },
    changeLanguage(lang){
      this.openLanuage = false;
        this.$i18n.locale =lang;
        this.$store.state.userInfo.langCode = lang;
    }
  },
  mounted: function() {
    var that = this;
    this.color = process.env.VUE_APP_API_TOPBAR_COLOR
  }
};
</script>
